(function ($) {
    
    function arrowClicks(){
        $('.nav-menu li .arrow').on('click',function(e) {
            e.preventDefault();
            $(this).next().addClass('active');
            $(this).parents('.menu-item').css('position','static');
        });
        $('.sidr__menu-back').on('click',function(){
            var menuCloseId = $( this ).data('sidr-menu');
            var menuId = menuCloseId.substring(5, menuCloseId.length);
            
            $('#'+menuCloseId).removeClass('active');
            $(this).parents('.menu-item').css('position','relative');
        });
    }
    
	/* Document Ready */
	$(document).ready(function() {
        
        AOS.init({
            duration: 400,
            once: true
//            anchorPlacement: 'top-bottom'
        });
        
        /* Jarallax requirements */
        // object-fit polyfill run
        objectFitImages();

        // init Jarallax
        jarallax(document.querySelectorAll('.jarallax'));

        jarallax(document.querySelectorAll('.jarallax-keep-img'), {
            keepImg: true,
        });

        
        //Sidr
        $('#mobile-trigger').sidr({
            side: 'left',
            name: 'sidr',
            displace: false,
            source : function() {
                var sidrHtml;
                
                sidrHtml = '<div id="mobile-menu">';
                
                sidrHtml += '<div class="sidr__header">';
                sidrHtml += '<div class="sidr__logo">' + $('.site-logo').html() + '</div>';
                sidrHtml += '<span class="sidr__close" aria-label="Close Menu"></span>';
                sidrHtml += '</div>';
                
                sidrHtml += '<div class="sidr__inner">';
                
                sidrHtml += '<div class="sidr__mainnav">' + $('.main-navigation').html() + '</div>';
                
                if($('.sub-navigation').length){
                    sidrHtml += '<div class="sidr__subnav">' + $('.sub-navigation').html() + '</div>';
                }
                
                sidrHtml += '</div>';
                
                if($('.site-footer-phone').length){
                    sidrHtml += '<div class="sidr__phone">' + $('.site-footer-phone').html() + '</div>';
                }
                
                sidrHtml += '</div>';
                    
                return sidrHtml;
            },
            onOpen: function() {
                $( 'body' ).prepend( '<div class="sidr-overlay"></div>' );
                
                $('.sidr__inner').find('.sub-menu').not(".sub-menu .sub-menu").each(function() {
                    var menuId = $(this).parents('.menu-item').attr('id');
                    var parentLink = $(this).prevAll('a').attr('href');
                    var parentText = $(this).prevAll('a').html();
                    $(this).attr('id','sidr-'+menuId).prepend('<li class="sidr__menu-back" data-sidr-menu="sidr-'+menuId+'">'+parentText+'</li>');
                });
            },
            onOpenEnd: function(){
                $( 'body' ).css({
                    "height": "100%",
                    "overflow": "hidden"
                });
                arrowClicks();
            },
            onClose: function(){
                $( '.sidr-overlay' ).remove();
            },
            onCloseEnd: function(){
                $('.sidr__inner').find('.sub-menu').each(function() {
                    $(this).find('.sidr__menu-back').remove();
                });
                $( 'body' ).css({
                    "height": "auto",
                    "overflow": "visible"
                });
            }
        });

        $('.sidr__close').click(function() {
            $.sidr('close','sidr');
            $('.nav-menu li .arrow').unbind();
        });

	});
    
    $(document).on("mousedown touchstart",function(event){
        if($(event.target).closest('#sitesearch--toggle').length && $(event.target).is('#sitesearch--toggle')) {
            $('#sitesearch').addClass('active');
            $.sidr('close','sidr');
        }
        if($(event.target).closest('#sitesearch--footer').length && $(event.target).is('#sitesearch--footer')) {
            $('#sitesearch').addClass('active');
            $.sidr('close','sidr');
        }
        if($(event.target).closest('#sitesearch--close').length && $(event.target).is('#sitesearch--close')) {
            $('#sitesearch').removeClass('active');
        }
        if($(event.target).closest('#sitesearch.active').length && $(event.target).is('#sitesearch.active')) {
            $("#sitesearch").removeClass('active');
        } 
    });
    
    // init AOS animation
//    window.addEventListener('load', function(){
//        AOS.init({
//            duration: 400,
//            once: false,
//            anchorPlacement: 'top-bottom'
//        });
//    });
    
    let samt = 0;
    window.addEventListener('scroll', function() {
        samt <= 10 ? samt++ : AOS.refresh();
    });
    

    
//    AOS.init({
//        duration: 400,
//        once: true,
//        anchorPlacement: 'top-bottom'
//    });
    
//    let samt = 0;
//    window.addEventListener('scroll', function() {
//        samt <= 10 ? samt++ : AOS.refresh();
//    });
    
//    $(window).on('load', function () {
//  AOS.refresh();
//});
//$(function () {
//  AOS.init();
//});

})(jQuery);